import {Injectable} from '@angular/core';
import {AuthService} from "./auth.service";
import {SettingsService} from "./settings.service";
import {
  SessionTimeoutWarnDialogComponent
} from "../shared/components/session-timeout-warn-dialog/session-timeout-warn-dialog.component";
import {environment} from "../../environments/environment";
import {StorageService} from "./storage.service";

@Injectable({
  providedIn: 'root'
})
export class InactivityTimerService {

  private timeoutId: any;

  private timeoutId2: any;

  private readonly countDownInMls = 30000;

  constructor(
    private authService: AuthService,
    private settingsService: SettingsService,
    private storageService: StorageService,
  ) {
  }

  startTimer(): void {
    this.resetTimer();
    const expiryTime: number = environment.SESSION_TIMEOUT;

    // make sure user is logged in
    if (!!this.storageService.getItem('currentClient')) {
      // popout warn modal
      if (expiryTime > this.countDownInMls) {
        const openSessionModalIn = expiryTime - this.countDownInMls;
        this.timeoutId2 = setTimeout(() => {
          this.settingsService.openDialogModal({
            width: '350px',
            component: SessionTimeoutWarnDialogComponent,
            data: this.countDownInMls
          });
        }, openSessionModalIn);
      }

      // logout in case of inactivity
      this.timeoutId = setTimeout(() => {
        this.authService.logout();
        this.settingsService.closeDialog(SessionTimeoutWarnDialogComponent);
      }, expiryTime);
    }
  }

  resetTimer(): void {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
    if (this.timeoutId2) {
      this.settingsService.closeDialog(SessionTimeoutWarnDialogComponent);
      clearTimeout(this.timeoutId2);
    }
  }

  refreshUserActivity(): void {
    this.startTimer();
  }
}
